// api
import { getWidgetsData } from 'shared/api/widgets';

// actions
import { ActionTypes } from './actions';

// type
import { IFetchWidgetDataProps } from 'shared/store/widgets/types';

export const fetchWidgetData = ({ productID, apiConfig }: IFetchWidgetDataProps): any => {
  return (dispatch: any) => {
    dispatch({ type: ActionTypes.FETCH_WIDGET_DATA_PROGRESS, payload: productID || '' });
    return getWidgetsData({
      productID,
      apiConfig,
    })
      .then((data) => {
        const payload = {
          productID,
          response: data.response,
        };

        dispatch({ type: ActionTypes.FETCH_WIDGET_DATA_SUCCESS, payload });
        return data;
      })
      .catch(() => {
        dispatch({ type: ActionTypes.FETCH_WIDGET_DATA_FAILED });
      });
  };
};
